export default {
  Id: {
    label: '_'
  },
  Type: {
    label: 'Type',
    width: 100
  },
  CertificateName: {
    label: 'Certificate Name',
    width: 250
  },
  CreatedDate: {
    label: 'Uploaded Date',
    width: 100
  },
  Actions: {
    label: ' ',
    width: 100,
    sortable: false
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Network/Insurance/models/supplier-certificate-model.js